// Catálogo de permissões do portal e leitura do claim permissions[] do token.
//
// Espelho de .claude/portal-catalog-sync.json, no repositório do VAULT: os dois
// são gerados da mesma tabela e têm de mudar juntos. Código que existe aqui e não
// lá nunca é concedido a ninguém; o contrário desativa a permissão no próximo sync.
//
// Formato: portal.<modulo>.<tela>.<acao> — minúsculo, sem acento, "." entre níveis
// e "-" dentro de um nível.
//
// `acessar` é a permissão de entrar na tela: sem ela o item não aparece no menu,
// a rota não abre e nenhuma ação de dentro pode ser concedida. As outras são os
// botões, com o verbo do que o botão faz.

const SYSTEM = "portal";

const code = (...segments: string[]): string => [SYSTEM, ...segments].join(".");

export const PortalPermissions = {
  administracao: {
    usuarios: {
      acessar: code("administracao", "usuarios", "acessar"),
      acessarComo: code("administracao", "usuarios", "acessar-como"),
      vincularAntecipadora: code("administracao", "usuarios", "vincular-antecipadora"),
      desvincularAntecipadora: code("administracao", "usuarios", "desvincular-antecipadora"),
    },
    empresas: {
      acessar: code("administracao", "empresas", "acessar"),
      criar: code("administracao", "empresas", "criar"),
      editar: code("administracao", "empresas", "editar"),
      exportar: code("administracao", "empresas", "exportar"),
    },
    pesquisaNps: {
      acessar: code("administracao", "pesquisa-nps", "acessar"),
      criar: code("administracao", "pesquisa-nps", "criar"),
      editar: code("administracao", "pesquisa-nps", "editar"),
    },
    taxasAntecipacao: {
      acessar: code("administracao", "taxas-antecipacao", "acessar"),
      criar: code("administracao", "taxas-antecipacao", "criar"),
      editar: code("administracao", "taxas-antecipacao", "editar"),
    },
    cadastroCliente: {
      acessar: code("administracao", "cadastro-cliente", "acessar"),
    },
  },
  transacoes: {
    vendas: {
      acessar: code("transacoes", "vendas", "acessar"),
      exportar: code("transacoes", "vendas", "exportar"),
    },
    recebiveis: {
      acessar: code("transacoes", "recebiveis", "acessar"),
      exportar: code("transacoes", "recebiveis", "exportar"),
    },
    pagamentos: {
      acessar: code("transacoes", "pagamentos", "acessar"),
      exportar: code("transacoes", "pagamentos", "exportar"),
      alterarStatus: code("transacoes", "pagamentos", "alterar-status"),
      concederDesconto: code("transacoes", "pagamentos", "conceder-desconto"),
    },
    depositos: {
      acessar: code("transacoes", "depositos", "acessar"),
      baixarComprovante: code("transacoes", "depositos", "baixar-comprovante"),
    },
    reprocessamento: {
      acessar: code("transacoes", "reprocessamento", "acessar"),
      reprocessar: code("transacoes", "reprocessamento", "reprocessar"),
      status: code("transacoes", "reprocessamento", "status"),
      reprocessarPix: code("transacoes", "reprocessamento", "reprocessar-pix"),
      statusPix: code("transacoes", "reprocessamento", "status-pix"),
    },
  },
  cancelamentos: {
    cancelarVenda: {
      acessar: code("cancelamentos", "cancelar-venda", "acessar"),
      cancelarVenda: code("cancelamentos", "cancelar-venda", "cancelar-venda"),
    },
    historico: {
      acessar: code("cancelamentos", "historico", "acessar"),
    },
  },
  edi: {
    detalhes: {
      acessar: code("edi", "detalhes", "acessar"),
      exportar: code("edi", "detalhes", "exportar"),
    },
    gerenciador: {
      acessar: code("edi", "gerenciador", "acessar"),
      baixarDoBanco: code("edi", "gerenciador", "baixar-do-banco"),
      processarArquivo: code("edi", "gerenciador", "processar-arquivo"),
      enviarArquivo: code("edi", "gerenciador", "enviar-arquivo"),
    },
  },
  cobrancas: {
    menu: {
      acessar: code("cobrancas", "menu", "acessar"),
      exportar: code("cobrancas", "menu", "exportar"),
    },
    cobrancaPontual: {
      acessar: code("cobrancas", "cobranca-pontual", "acessar"),
      criar: code("cobrancas", "cobranca-pontual", "criar"),
      editar: code("cobrancas", "cobranca-pontual", "editar"),
      exportar: code("cobrancas", "cobranca-pontual", "exportar"),
    },
    produtosContratados: {
      acessar: code("cobrancas", "produtos-contratados", "acessar"),
      exportar: code("cobrancas", "produtos-contratados", "exportar"),
      concederDesconto: code("cobrancas", "produtos-contratados", "conceder-desconto"),
    },
    chargebacks: {
      acessar: code("cobrancas", "chargebacks", "acessar"),
      exportar: code("cobrancas", "chargebacks", "exportar"),
      contestar: code("cobrancas", "chargebacks", "contestar"),
      estornar: code("cobrancas", "chargebacks", "estornar"),
      alterarStatus: code("cobrancas", "chargebacks", "alterar-status"),
    },
    antecipacaoPontual: {
      acessar: code("cobrancas", "antecipacao-pontual", "acessar"),
      solicitar: code("cobrancas", "antecipacao-pontual", "solicitar"),
      baixarComprovante: code("cobrancas", "antecipacao-pontual", "baixar-comprovante"),
    },
    historicoAntecipacao: {
      acessar: code("cobrancas", "historico-antecipacao", "acessar"),
      exportar: code("cobrancas", "historico-antecipacao", "exportar"),
    },
  },
  liquidacao: {
    vendas: {
      acessar: code("liquidacao", "vendas", "acessar"),
      consultar: code("liquidacao", "vendas", "consultar"),
      exportar: code("liquidacao", "vendas", "exportar"),
    },
    recebiveis: {
      acessar: code("liquidacao", "recebiveis", "acessar"),
      consultar: code("liquidacao", "recebiveis", "consultar"),
      exportar: code("liquidacao", "recebiveis", "exportar"),
    },
  },
  slc: {
    pagamentos: {
      acessar: code("slc", "pagamentos", "acessar"),
      exportar: code("slc", "pagamentos", "exportar"),
      baixarComprovante: code("slc", "pagamentos", "baixar-comprovante"),
    },
    liquidacoesFalhas: {
      acessar: code("slc", "liquidacoes-falhas", "acessar"),
      exportar: code("slc", "liquidacoes-falhas", "exportar"),
    },
  },
  contratos: {
    cadastroCredores: {
      acessar: code("contratos", "cadastro-credores", "acessar"),
      criar: code("contratos", "cadastro-credores", "criar"),
      editar: code("contratos", "cadastro-credores", "editar"),
    },
    consultaEfeitos: {
      acessar: code("contratos", "consulta-efeitos", "acessar"),
    },
    efeitosCumpridos: {
      acessar: code("contratos", "efeitos-cumpridos", "acessar"),
      darBaixa: code("contratos", "efeitos-cumpridos", "dar-baixa"),
    },
    contratosTermos: {
      acessar: code("contratos", "contratos-termos", "acessar"),
      baixarContrato: code("contratos", "contratos-termos", "baixar-contrato"),
      assinar: code("contratos", "contratos-termos", "assinar"),
      assinados: code("contratos", "contratos-termos", "assinados"),
      assinadosCliente: code("contratos", "contratos-termos", "assinados-cliente"),
      assinadoEspecifico: code("contratos", "contratos-termos", "assinado-especifico"),
      pendencias: code("contratos", "contratos-termos", "pendencias"),
    },
  },
  linkPagamento: {
    gerar: {
      acessar: code("link-pagamento", "gerar", "acessar"),
      gerar: code("link-pagamento", "gerar", "gerar"),
    },
    historico: {
      acessar: code("link-pagamento", "historico", "acessar"),
      exportar: code("link-pagamento", "historico", "exportar"),
      excluir: code("link-pagamento", "historico", "excluir"),
      baixarComprovante: code("link-pagamento", "historico", "baixar-comprovante"),
    },
  },
  assinaturas: {
    gerar: {
      acessar: code("assinaturas", "gerar", "acessar"),
      gerar: code("assinaturas", "gerar", "gerar"),
    },
    historico: {
      acessar: code("assinaturas", "historico", "acessar"),
      excluir: code("assinaturas", "historico", "excluir"),
    },
  },
  simulador: {
    recebimento: {
      acessar: code("simulador", "recebimento", "acessar"),
    },
    venda: {
      acessar: code("simulador", "venda", "acessar"),
    },
  },
  terminais: {
    phoebus: {
      acessar: code("terminais", "phoebus", "acessar"),
      exportar: code("terminais", "phoebus", "exportar"),
    },
  },
  financeiro: {
    extrato: {
      acessar: code("financeiro", "extrato", "acessar"),
      exportar: code("financeiro", "extrato", "exportar"),
    },
    taxas: {
      acessar: code("financeiro", "taxas", "acessar"),
      baixarTabela: code("financeiro", "taxas", "baixar-tabela"),
    },
    politicasCobranca: {
      acessar: code("financeiro", "politicas-cobranca", "acessar"),
      criar: code("financeiro", "politicas-cobranca", "criar"),
      editar: code("financeiro", "politicas-cobranca", "editar"),
      excluir: code("financeiro", "politicas-cobranca", "excluir"),
    },
  },
  comercial: {
    dashboard: {
      acessar: code("comercial", "dashboard", "acessar"),
    },
    areaParceiro: {
      acessar: code("comercial", "area-parceiro", "acessar"),
    },
  },
  conta: {
    acessoConta: {
      acessar: code("conta", "acesso-conta", "acessar"),
    },
  },
} as const;

/**
 * Permissões que dão acesso a cada área do portal, usadas pelos AuthGate.
 *
 * O userType continua escolhendo *qual* área o usuário enxerga — as rotas de PF, PJ,
 * Comercial e Parceiro se sobrepõem (todas têm /painel-de-vendas), e decidir só por
 * permissão faria duas áreas casarem o mesmo caminho. O que muda é a autorização:
 * dentro da área, entrar depende de poder acessar ao menos uma tela dela.
 */
export const AreaPermissions = {
  admin: [
    PortalPermissions.administracao.usuarios.acessar,
    PortalPermissions.administracao.empresas.acessar,
    PortalPermissions.transacoes.vendas.acessar,
    PortalPermissions.transacoes.recebiveis.acessar,
    PortalPermissions.transacoes.pagamentos.acessar,
    PortalPermissions.transacoes.reprocessamento.acessar,
    PortalPermissions.cancelamentos.cancelarVenda.acessar,
    PortalPermissions.slc.pagamentos.acessar,
  ],
  comercial: [
    PortalPermissions.administracao.usuarios.acessar,
    PortalPermissions.administracao.empresas.acessar,
    PortalPermissions.transacoes.vendas.acessar,
    PortalPermissions.transacoes.recebiveis.acessar,
    PortalPermissions.comercial.dashboard.acessar,
  ],
  parceiro: [
    PortalPermissions.administracao.usuarios.acessar,
    PortalPermissions.administracao.empresas.acessar,
    PortalPermissions.transacoes.vendas.acessar,
    PortalPermissions.transacoes.recebiveis.acessar,
    PortalPermissions.comercial.areaParceiro.acessar,
  ],
  pessoaFisica: [
    PortalPermissions.transacoes.vendas.acessar,
    PortalPermissions.transacoes.recebiveis.acessar,
    PortalPermissions.cobrancas.menu.acessar,
    PortalPermissions.financeiro.extrato.acessar,
  ],
  pessoaJuridica: [
    PortalPermissions.transacoes.vendas.acessar,
    PortalPermissions.transacoes.recebiveis.acessar,
    PortalPermissions.cobrancas.menu.acessar,
    PortalPermissions.financeiro.extrato.acessar,
  ],
  antecipadora: [
    PortalPermissions.transacoes.vendas.acessar,
    PortalPermissions.transacoes.recebiveis.acessar,
  ],
  contaSplit: [
    PortalPermissions.financeiro.extrato.acessar,
    PortalPermissions.conta.acessoConta.acessar,
  ],
} as const;

interface IJwtClaims {
  permissions?: string[];
  exp?: number;
}

const decodeSegment = (segment: string): IJwtClaims | null => {
  try {
    const normalized = segment.replace(/-/g, "+").replace(/_/g, "/");
    const padded = normalized.padEnd(
      normalized.length + ((4 - (normalized.length % 4)) % 4),
      "="
    );

    return JSON.parse(decodeURIComponent(escape(window.atob(padded)))) as IJwtClaims;
  } catch {
    return null;
  }
};

/**
 * Lê os claims do access token do VAULT. Sem verificação de assinatura de propósito:
 * quem valida o token é o back-end. Aqui o claim serve para não desenhar um menu nem
 * um botão que o servidor recusaria — adulterá-lo no browser revela controles que
 * continuam negados na chamada.
 */
export const readTokenClaims = (): IJwtClaims | null => {
  try {
    const raw = localStorage.getItem("accessToken");

    if (!raw) return null;

    const parsed = JSON.parse(raw) as { token?: string } | null;
    const segments = parsed?.token?.split(".");

    return segments && segments.length === 3 ? decodeSegment(segments[1]) : null;
  } catch {
    return null;
  }
};

export const getPermissions = (): string[] => readTokenClaims()?.permissions ?? [];

/**
 * Verdadeiro quando o token concede a permissão informada.
 *
 * Token sem o claim permissions[] libera tudo: é o estado de quem ainda autentica pelo
 * caminho legado, durante a transição. Trocar isso por negar tudo esvaziaria a tela de
 * todo usuário não migrado.
 */
export const can = (permission: string): boolean => {
  const claims = readTokenClaims();

  if (!claims || claims.permissions === undefined) return true;

  return claims.permissions.includes(permission);
};

/** Verdadeiro quando o token concede ao menos uma das permissões. */
export const canAny = (...permissions: string[]): boolean =>
  permissions.some(can);

export default { PortalPermissions, AreaPermissions, can, canAny, getPermissions, readTokenClaims };
